if (!customElements.get('wls-countdown')) {
  class WLSCountdown extends HTMLElement {
    constructor() {
      super();

      this.countdownInterval = null;
    }

    /**
     * Lifecycle method called when the element is added to the DOM.
     * It initializes the countdown timer.
     *
     * @returns {void}
     */
    connectedCallback() {
      this.initializeCountdown();
    }

    /**
     * Initialize countdown timer
     *
     * @returns {void}
     */
    initializeCountdown() {
      const dateStr = this.getAttribute('data-countdown-date');
      const timeStr = this.getAttribute('data-countdown-time') || '00:00';

      if (!dateStr) return;

      // Parse date and time
      const dateParts = dateStr.split('-');
      const [month, day, year] = dateParts.map(Number);
      const timeParts = timeStr.split(':');
      const [hours, minutes] = timeParts.map(Number);

      const targetDate = new Date(year, month - 1, day, hours || 0, minutes || 0, 0);

      const daysEl = this.querySelector('.wls-countdown-days');
      const hoursEl = this.querySelector('.wls-countdown-hours');
      const minutesEl = this.querySelector('.wls-countdown-minutes');
      const secondsEl = this.querySelector('.wls-countdown-seconds');

      if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

      // Update immediately
      this.updateCountdown(targetDate, daysEl, hoursEl, minutesEl, secondsEl);

      // Update every second
      this.countdownInterval = setInterval(() => {
        const shouldContinue = this.updateCountdown(targetDate, daysEl, hoursEl, minutesEl, secondsEl);
        if (!shouldContinue) {
          clearInterval(this.countdownInterval);
          this.countdownInterval = null;
        }
      }, 1000);
    }

    /**
     * Update countdown display
     *
     * @param {Date} targetDate - The target date and time
     * @param {HTMLElement} daysEl - Days element
     * @param {HTMLElement} hoursEl - Hours element
     * @param {HTMLElement} minutesEl - Minutes element
     * @param {HTMLElement} secondsEl - Seconds element
     * @returns {boolean} - Returns false if countdown has expired
     */
    updateCountdown(targetDate, daysEl, hoursEl, minutesEl, secondsEl) {
      const now = new Date();
      const difference = targetDate - now;

      if (difference <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        this.classList.add('wls-countdown-expired');
        return false;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      daysEl.textContent = String(days).padStart(2, '0');
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');

      return true;
    }

    /**
     * Lifecycle method called when the element is removed from the DOM.
     * It cleans up the countdown interval.
     *
     * @returns {void}
     */
    disconnectedCallback() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    }
  }

  window.customElements.define('wls-countdown', WLSCountdown);
}

// Set CSS variable for promo bar height
function setPromoBarHeight() {
  const promoBar = document.querySelector('.wls-promo-bar');
  if (promoBar) {
    const height = promoBar.offsetHeight;
    document.documentElement.style.setProperty('--wls-promo-bar-height', `${height}px`);
  }
}

// Initialize on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setPromoBarHeight);
} else {
  setPromoBarHeight();
}

window.addEventListener('load', setPromoBarHeight);
window.addEventListener('resize', setPromoBarHeight);
